import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import apiClient from '../../../../../api/apiClient';
import { usePreloaderStore } from '../../../../../stores';
import Modal from '../../controls/Modal';
import LabeledInput from '../../controls/LabeledInput';
import SpiteToggle from './SpiteToggle';

// Модалка создания/редактирования категории шаблонов (название, описание, лимиты).
export default function TemplateCategoryModal({ category, packId, onSuccess, onClose }) {
    const editing = !!category;
    const { enqueueSnackbar } = useSnackbar();
    const { show, hide } = usePreloaderStore();
    const [name, setName] = useState(category?.name || '');
    const [desc, setDesc] = useState(category?.description || '');
    const [ratio, setRatio] = useState(category?.ratioLimit ? String(category.ratioLimit) : '');
    const [daily, setDaily] = useState(category?.dailyLimit ? String(category.dailyLimit) : '');
    const [notify, setNotify] = useState(category?.notifyOrganizersOnPurchase || false);

    const submit = async () => {
        if (!name.trim()) { enqueueSnackbar('Введите название категории', { variant: 'warning' }); return; }
        const data = {
            name: name.trim(),
            description: desc,
            ratioLimit: ratio ? parseFloat(ratio) : null,
            dailyLimit: daily ? parseInt(daily, 10) : null,
            notifyOrganizersOnPurchase: notify
        };
        show();
        try {
            if (editing) {
                await apiClient.patch(`/api/neighbor/admin/task-template-categories/update?id=${category.id}`, data);
            } else {
                await apiClient.post('/api/neighbor/admin/task-template-categories/create', { ...data, packId });
            }
            enqueueSnackbar('Сохранено', { variant: 'success' });
            onSuccess();
            onClose();
        } catch (e) { enqueueSnackbar(e.response?.data?.message || 'Ошибка при сохранении', { variant: 'error' }); }
        finally { hide(); }
    };

    const del = async () => {
        show();
        try {
            await apiClient.delete(`/api/neighbor/admin/task-template-categories/delete?id=${category.id}`);
            enqueueSnackbar('Категория удалена', { variant: 'success' });
            onSuccess();
            onClose();
        } catch (e) { enqueueSnackbar('Ошибка при удалении', { variant: 'error' }); }
        finally { hide(); }
    };

    const footer = (
        <>
            {editing && <button type="button" className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={del}>Удалить</button>}
            <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
            <button type="button" className="btn btn-primary" onClick={submit}>{editing ? 'Сохранить' : 'Создать'}</button>
        </>
    );

    return (
        <Modal open kicker="Категория" title={editing ? 'Редактирование категории' : 'Создание категории'} onClose={onClose} footer={footer}>
            <LabeledInput label="Название" value={name} onChange={(e) => setName(e.target.value)} />
            <div>
                <label className="ctl-label">Описание</label>
                <textarea className="textarea" value={desc} onChange={(e) => setDesc(e.target.value)} />
            </div>
            <div className="fr-grid2">
                <LabeledInput label="Коэффициент" type="number" value={ratio} onChange={(e) => setRatio(e.target.value)} placeholder="напр. 2" />
                <LabeledInput label="Лимит в день" type="number" value={daily} onChange={(e) => setDaily(e.target.value)} />
            </div>
            <div className="sp-sec">
                <div className="sp-tgs">
                    <SpiteToggle label="Уведомлять организаторов о покупке" checked={notify} onChange={() => setNotify(!notify)} full />
                </div>
                <div className="sp-notify-hint">
                    Флаг наследуется сменами: при импорте пака и «Синхронизировать с паком» категории смены получат это значение.
                </div>
            </div>
        </Modal>
    );
}

TemplateCategoryModal.propTypes = {
    category: PropTypes.object,
    packId: PropTypes.number,
    onSuccess: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

TemplateCategoryModal.defaultProps = { category: null, packId: null };
